import { Routes } from '@angular/router';
import { permissionGuard } from 'src/lib/guards/permission.guard';
import { FEATURED_MEMBER_CONFIG } from './base/featured-member-config';

/**
 * 이달의 위원 (FeaturedMember) Feature Routes
 *
 * URL: /featured-member
 * - /featured-member        → list (redirect)
 * - /featured-member/list   → list page
 * - /featured-member/list/:id → detail (nested)
 *
 * 권한: FEATURED_MEMBER$READ
 */
export const featuredMemberRoutes: Routes = [
  {
    path: FEATURED_MEMBER_CONFIG.routePath, // 'featured-member'
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/featured-member-list-page/featured-member-list-page.component'
          ).then((m) => m.FeaturedMemberListPageComponent),
        canActivate: [
          permissionGuard(...(FEATURED_MEMBER_CONFIG.permissions ?? [])),
        ],
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/featured-member-detail-page/featured-member-detail-page.component'
              ).then((m) => m.FeaturedMemberDetailPageComponent),
          },
        ],
      },
    ],
  },
];
